import { Injectable } from '@angular/core';
import { Globals } from '../globals';
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiAuthService } from './api-auth.service';
import { Proveedor } from '../models/Proveedor';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class ApiDownloadFileService {
  private headers: HttpHeaders;
  private usuario: Proveedor;
  private RFC: string;
  
  constructor(public globals: Globals, private httpApi: HttpClient, private apiAuth: ApiAuthService) { 
    this.usuario = apiAuth.getTokenDecoded();

    if (isNullOrUndefined(this.usuario)) {
      this.RFC = "Publico";
    } else {
      this.RFC = this.usuario.RFC;
    }
  }
 
  descargaArchivo(cvedoc: string) {
    location.href = this.globals.BASE_URL + `getDescargaDocumento?n_cvedoc=${ cvedoc }`;
  }

  downloadFile(Id: string, facturas: boolean = false): Observable<any> {
    this.actualizaHeader();

    let url = this.globals.BASE_URL + "getDescargaDocumento_E?n_cvedoc=" + Id + "&facturas=" + facturas + "&usuario=" + this.RFC;
    return this.httpApi.get(url, { responseType: "blob", headers: this.headers });
  }

  private actualizaHeader() {
    let token = this.apiAuth.getToken() !== null ? this.apiAuth.getToken().replace(/["\\]/g, '') : '';
    token = token.replace(/["\\]/g, '');

    this.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
      "Authorization": `Bearer ${token}`
    });
  }
}
